import React from "react";
import { Paper } from "convertupleads-theme";
import IconList from "./IconList";

const IconPage = () => {
  return (
    <Paper elevation={0}>
      <IconList />
    </Paper>
  );
};

export default IconPage;
